export default __webpack_public_path__ + "static/media/hero-bg.3f7909e9.jpg";